import script from "./CardPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CardPlayer.vue?vue&type=style&index=0&id=1f300bce&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f300bce"]])

export default __exports__